import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { AppComponent } from '../app.component';
import { ApiService } from '../services/api.service';
import { PermissionsService } from '../services/permissions.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationPopoverComponent } from '../confirmation-popover/confirmation-popover.component';

@Component({
  selector: 'app-dharmshala-reservations-list',
  templateUrl: './dharmshala-reservations-list.component.html',
  styleUrls: ['./dharmshala-reservations-list.component.scss']
})
export class DharmshalaReservationsListComponent implements OnInit {
  public payment_report: any;
  allDharmshalaBooking: any;
  public from_date = moment(new Date()).format('YYYY-MM-DD');
  public to_date = moment(new Date()).format('YYYY-MM-DD');
  public payment_status = 'Pending';
  public onChangeSearch = new Subject<string>();
  public perPage = 10;
  public totalCount = 0;
  public page = 1;
  public maxDate = '';
  public expandedBookingId: number | null = null;
  public selectedReservationDetail: any = null; // moment(new Date()).format('YYYY-MM-DD');

  constructor(
    private apiService: ApiService,
    private appComponent: AppComponent,
    public permissionsService: PermissionsService,
    private modalService: NgbModal

    ) { }

  ngOnInit() {
    this.getList('');
  }

  getList(_type) {
    this.appComponent.showLoader();
    const from_date = moment(this.from_date).format('YYYY-MM-DD');
    const to_date = moment(this.to_date).format('YYYY-MM-DD');
    this.apiService.getDataFromServer(`/reservations?from_date=${from_date}&to_date=${to_date}&page=${this.page}&perpage=${this.perPage}`).subscribe(
      (res: any) => { 
        this.appComponent.hideLoader();
        this.allDharmshalaBooking = res;
        this.allDharmshalaBooking.data.map(res => {
          res.from_date = moment.utc(res.from_date).local().format('DD-MM-YYYY');
          res.to_date = moment.utc(res.to_date).local().format('DD-MM-YYYY');
        });
        this.totalCount = res.total;
      },
      err => {
        console.log(err);
      }
    );
  }

  toggleBookingRooms(bookingId: number) {
    if (this.expandedBookingId === bookingId) {
      this.expandedBookingId = null;
    } else {
      this.expandedBookingId = bookingId;
    }
  }

  getReservationDetail(reservationId: number) {
    this.appComponent.showLoader();
    this.apiService.getDataFromServer(`/reservations/${reservationId}`).subscribe(
      (res: any) => {
        this.appComponent.hideLoader();
        if (res.success) {
          this.selectedReservationDetail = res.data;
          console.log('Reservation Detail:', this.selectedReservationDetail);
        }
      },
      err => {
        this.appComponent.hideLoader();
        console.log(err);
        const errorMessage = (err.error && err.error.message) ? err.error.message : 'Failed to fetch reservation details';
        this.appComponent.showMessageAlert(errorMessage, 'danger');
      }
    );
  }

  deleteEntireBooking(reservationId: number) {
    const modalRef = this.modalService.open(ConfirmationPopoverComponent, {
      centered: false, size: 'sm', windowClass: 'my-class', scrollable: false,
      backdrop: 'static', keyboard: false,
    });
    const deleteComponent: ConfirmationPopoverComponent = modalRef.componentInstance;
    deleteComponent.massage = 'Are you sure you want to delete this entire booking? This action cannot be undone.';
    modalRef.result.then((result) => {
      if (result === 'success') {
        this.appComponent.showLoader();
        this.apiService.deleteDataFromServer(`/reservations/${reservationId}`).subscribe(
          (res: any) => {
            this.appComponent.hideLoader();
            if (res.success) {
              this.appComponent.showMessageAlert(res.message, 'success');
              this.getList('');
            }
          },
          err => {
            this.appComponent.hideLoader();
            console.log(err);
            const errorMessage = (err.error && err.error.message) ? err.error.message : 'Failed to delete booking';
            this.appComponent.showMessageAlert(errorMessage, 'danger');
          }
        );
      }
    });
  }

  deleteSingleRoom(reservationId: number, roomId: number) {
    const modalRef = this.modalService.open(ConfirmationPopoverComponent, {
      centered: false, size: 'sm', windowClass: 'my-class', scrollable: false,
      backdrop: 'static', keyboard: false,
    });
    const deleteComponent: ConfirmationPopoverComponent = modalRef.componentInstance;
    deleteComponent.massage = 'Are you sure you want to delete this room from the booking?';
    modalRef.result.then((result) => {
      if (result === 'success') {
        this.appComponent.showLoader();
        this.apiService.deleteDataFromServer(`/reservations/${reservationId}/rooms/${roomId}`).subscribe(
          (res: any) => {
            this.appComponent.hideLoader();
            if (res.success) {
              this.appComponent.showMessageAlert(res.message, 'success');
              this.getList('');
            }
          },
          err => {
            this.appComponent.hideLoader();
            console.log(err);
            const errorMessage = (err.error && err.error.message) ? err.error.message : 'Failed to delete room';
            this.appComponent.showMessageAlert(errorMessage, 'danger');
          }
        );
      }
    });
  }


}